




































import { Component, mixins } from 'nuxt-property-decorator';

import { formatSv } from '@/composables/datefns';
import { PageContentMixin } from '@/composables/page-content';

import { NewsArticleContentDataFragment } from '@/graphql/generated';

@Component
export default class NewsPage extends mixins(PageContentMixin<NewsArticleContentDataFragment>()) {
  get page () {
    return {
      title: this.pageContent.title,
      slug: '',
    };
  }

  get publishedAt () {
    return formatSv(new Date(this.pageContent.publishedAt), 'd MMMM y');
  }
}
